module.exports = {
  admin: 'Admin',
  project_admin: 'Project Admin',
  collaborator: 'Collaborator',
  viewer: 'Viewer',
}